import { FC } from "react";
import { Navigate } from "react-router-dom";

import { IUser } from "@framework/types";
import { useUser } from "@framework/provider-user";

export const Landing: FC = () => {
  const { profile, isLoading } = useUser<IUser>();

  if (isLoading) {
    return null;
  }

  if (!profile) {
    return <Navigate to="/login" />;
  }

  return <Navigate to="/dashboard" replace={true} />;
};
